export default function CsharpSwitch() {
  return (
    <h2>Csharp Switch</h2>
  );
}
